import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Log',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'answeredAt',
        'locationNumber',
        'nickName',
        'answer',
        'responseStatus'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          answeredAt: '回答日時',
          locationNumber: 'ロケーションID',
          // 202305 機能選択に「見守り未回答通知機能」を追加 ST
          nickName: 'プロフィール１',
          // 202305 機能選択に「見守り未回答通知機能」を追加 ED
          answer: '回答',
          responseStatus: '対応状況'
        },
        columnsClasses: {
          answeredAt: '',
          locationNumber: '',
          nickName: '',
          answer: '',
          responseStatus: 'wp-10'
        },
        sortable: [
          'answeredAt',
          'locationNumber',
          'nickName',
          'answer',
          'responseStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 検索
      searchService: '',
      searchFunction: '',
      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      serviceFunctionUuid:'',
      followNoReply: false,
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED
      searchDate: '',
      searched: false,

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.log.categoryName,
      logModel: state => state.log.logModel,
      serviceModel: state => state.log.serviceModel,
      serviceFunctionModel: state => state.log.serviceFunctionModel,
      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      serviceFunctionDetailModel: state => state.log.serviceFunctionDetailModel,
      noReplyEndDate: state => state.log.noReplyEndDate,
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED
      serviceInfoModel: state => state.log.serviceInfoModel,
      // modal
      updatedList: state => state.logStatusModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    serviceList () {
      let list = []
      this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .forEach(item => list.push({
        value: item.serviceUuid,
        label: item.serviceName
      }))
      return list
    },
    functionList () {
      let list = []
      this.serviceFunctionModel.forEach(item => list.push({
        value: item.functionMstUuid,
        label: item.functionName
      }))
      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      if (this.serviceFunctionDetailModel) {
          list.push({
              value: Constants.Mst.FunctionDeliveryType.followNoReply,
              label: '見守り未回答検知機能（前日回答まで）'
          })
      }
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED
      return list
    },
    logDateList () {
      if (!this.selectedService) return []

      // 選択されたサービスの登録月を取得
      let timestamp = this.isAdmin
        ? this.serviceModel.find(item => item.serviceUuid === this.searchService).createdAt
        : this.serviceInfoModel.createdAt
      let startMonth = Utility.dateFormat(timestamp, 'YYYYMM')

      // 現在月を取得
      let date = moment()

      // 直近6ヶ月の場合
      let list = []
      list.push({
        value: date.format('YYYYMM'),
        label: date.format('YYYY年M月')
      })
      for (let i = 0, l = 5; i < l; i++) {
        date.add(-1, 'M')
        if (date.format('YYYYMM') < startMonth) break
        list.push({
          value: date.format('YYYYMM'),
          label: date.format('YYYY年M月')
        })
      }
      return list
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },

    // enable
    selectedService () {
      return this.searchService !== ''
    },
    disableSearchButton () {
      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      if (this.followNoReply) {
          return this.searchService === '' ||
              this.searchFunction === ''
      } else {
          return this.searchService === '' ||
              this.searchFunction === '' ||
              this.searchDate === ''
      }
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    buttonClass() {
      return props => {
        return 'status' + props.row.responseStatus
      }
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ST
    noReplyEndDateView() {
        if (this.followNoReply)
            return this.noReplyEndDate
        else
            return null
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ED
  },
  watch: {
    updatedList: function (to) {
      if (!to) return
      
      setTimeout(() => {
        this.search()
      }, 500);
    },
    // サービスが選択されたら紐づく機能リストを取得
    searchService: function (to) {
      if (to) {
        this.loading = true

        let serviceFunctionParams = {
          serviceUuid: to
        }

        this.loadServiceFunctionList({
          serviceFunctionParams: serviceFunctionParams
        })
          // eslint-disable-next-line
          .then(res => {
            // 202305 機能選択に「見守り未回答通知機能」を追加 ST
            this.serviceFunctionUuid = this.serviceFunctionModel.length 
              ? this.serviceFunctionModel.find(item => item.functionName === Constants.Mst.FunctionDeliveryType.follow).serviceFunctionUuid
              : ''
            // 202305 機能選択に「見守り未回答通知機能」を追加 ED
            this.loading = false
          })
          .catch(error => {
            this.showError(error || null)
          })
      }
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ST
    serviceFunctionUuid:function (to){
      if (to){
        let serviceFunctionDetailParams = {
          serviceUuid: this.searchService,
          serviceFunctionUuid: this.serviceFunctionUuid
        }
        this.loadServiceFunctionDetail({
          serviceFunctionDetailParams: serviceFunctionDetailParams
        })
          // eslint-disable-next-line
          .then(res => {
            this.loading = false
          })
          .catch(error => {
            this.showError(error || null)
          })
      }
    },
    searchFunction: function () {
        if (this.searchFunction === Constants.Mst.FunctionDeliveryType.followNoReply)
            this.followNoReply = true
        else this.followNoReply = false
        this.remakeTableOptionsItem()
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ED
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showToast: 'toast/show',
      loadModel: 'log/loadModel',
      loadLogList: 'log/loadLogList',
      loadServiceFunctionList: 'log/loadServiceFunctionList',
      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      loadServiceFunctionDetail: 'log/loadServiceFunctionDetail',
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED
      showLogStatusModal: 'logStatusModal/show'
    }),

    init () {
      this.loading = true

      const serviceParams = this.isAdmin
        ? {}
        : {
          serviceUuid: this.userServiceUuid
        }

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false

          if (this.isOperator) {
            this.searchService = this.userServiceUuid
          }
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        // 202305 機能選択に「見守り未回答通知機能」を追加 ST
        case 'continuousDaysNoReply':
            if (!value) return Constants.BlankValue
            return value + '日'
        // 202305 機能選択に「見守り未回答通知機能」を追加 ED
        case 'answeredAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
        case 'answer':
          if (!value) return Constants.BlankValue
          return JSON.parse(value).answerMessage ||
            JSON.parse(value).labelText
        case 'responseStatus':
          return Utility.getConstantsLabel(['Log', 'ResponseStatus'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchService = ''
      this.searchFunction = ''
      this.searchDate = ''

      this.searched = false

      this.init()
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ST
    followTableOptionsItem(){
        this.tableColumns = [
            'answeredAt',
            'locationNumber',
            'nickName',
            'answer',
            'responseStatus'
        ]
        this.tableOptions.headings = {
            answeredAt: '回答日時',
            locationNumber: 'ロケーションID',
            nickName: 'プロフィール１',
            answer: '回答',
            responseStatus: '対応状況'
        }
        this.tableOptions.columnsClasses = {
            answeredAt: '',
            locationNumber: '',
            nickName: '',
            answer: '',
            responseStatus: 'wp-10'
        }
        this.tableOptions.sortable = [
            'answeredAt',
            'locationNumber',
            'nickName',
            'answer',
            'responseStatus'
        ]
    },
    noReplyTableOptionsItem() {
        this.tableColumns = [
            'locationNumber',
            'serial_no',
            'profile',
            'lastAnswerDt',
            'continuousDaysNoReply'
        ]
        this.tableOptions.headings = {
            locationNumber: 'ロケーションID',
            serial_no: '製造番号',
            profile: 'プロフィール１',
            lastAnswerDt: '最終回答日時',
            continuousDaysNoReply: '連続未回答日数'
        }
        this.tableOptions.columnsClasses = {
            locationNumber: '',
            serial_no: '',
            profile: '',
            lastAnswerDt: '',
            continuousDaysNoReply: ''
        }
        this.tableOptions.sortable = [
            'locationNumber',
            'serial_no',
            'profile',
            'lastAnswerDt',
            'continuousDaysNoReply'
        ]
    },
    remakeTableOptionsItem() {
        if (this.followNoReply)
            this.noReplyTableOptionsItem()
        else
            this.followTableOptionsItem()
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ED
    search () {
      this.loading = true

      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      let logParams = {}
      if (this.followNoReply) {
          logParams = {
              filters:{
                  serviceUuid: this.searchService,
                  functionMstUuid: this.searchFunction,
                  locationUuid: ''
              }
          }
      } else {
          //
          logParams = {
              filters: {
                  serviceUuid: this.searchService,
                  functionMstUuid: this.searchFunction,
                  yearMonth: this.searchDate,
                  key: Utility.generateUuid()
              }
          }
      }
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED

      // データ読出し
      this.loadLogList({
        logParams: logParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.logModel)
          this.searched = true
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    // ログダウンロード
    downloadLog () {
      this.processing = true

      // パラメータを生成
      // 202305 機能選択に「見守り未回答通知機能」を追加 ST
      let parameters = {}
      let methods = []
      if (this.followNoReply) {
          parameters = {
            filters:{
                serviceUuid: this.searchService
            }
        }
        methods.push('v1LogNoReplyResponseDownload')
      } else {
        parameters = {
            filters: {
                serviceUuid: this.searchService,
                functionMstUuid: this.searchFunction,
                yearMonth: this.searchDate,
                key: Utility.generateUuid()
            }
        }
        methods.push('v1LogFunctionalDownload')
        }
      // 202305 機能選択に「見守り未回答通知機能」を追加 ED
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['log'],
          methods,
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            const serviceName = this.isAdmin
              ? this.serviceList.find(item => item.value === this.searchService).label
              : this.serviceInfoModel.serviceName
            const functionName = this.functionList.find(item => item.value === this.searchFunction).label
            // 202305 機能選択に「見守り未回答通知機能」を追加 ST
            let name = serviceName + '_' + functionName
            if (this.followNoReply){
                const date = new Date()
                const fullYear = date.getFullYear()
                let month = date.getMonth() + 1
                if (month < 10) month = '0' + month
                let day = date.getDate()
                if (day < 10) day = '0' + day
                name += '_' + fullYear.toString() + month + day
            } else {
                name += '_' + this.searchDate
            }
            // 202305 機能選択に「見守り未回答通知機能」を追加 ED

            Utility.downloadDataAsCsv(res[0].data, name + '.csv')

            // // toast
            // this.showToast({
            //   title: '',
            //   body: 'ログをダウンロードしました。'
            // })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    showStatusModal (props) {
      this.showLogStatusModal(props.row.functionResponseUuid)
    }
  }
}